import { FC } from 'react';
import { css } from '@emotion/react';
import { colors, spacing } from '../../styles';
import { FontSize, fontSizeLabels } from '../../utils/fontSizeManager';

interface Props {
  selectedSize: FontSize;
  onChange: (size: FontSize) => void;
}

const sizeOptions: { value: FontSize; fontSize: string }[] = [
  { value: 'small', fontSize: '12px' },
  { value: 'default', fontSize: '16px' },
  { value: 'large', fontSize: '20px' },
  { value: 'extra-large', fontSize: '24px' },
];

const FontSizeSelector: FC<Props> = ({ selectedSize, onChange }) => {
  return (
    <div
      css={css`
        display: flex;
        flex: 1;
        gap: ${spacing.milli};
        padding: ${spacing.micro};
        background: ${colors.fog};
        border-radius: 12px;
        border: 0.5px solid ${colors.liquorice}20;

        html[data-theme='dark'] & {
          background: rgba(80, 78, 75, 0.3);
          border-color: ${colors.cloud}30;
        }
      `}
      role="radiogroup"
      aria-label="Text size selection"
    >
      {sizeOptions.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          aria-label={`${fontSizeLabels[option.value]} text`}
          aria-pressed={selectedSize === option.value}
          css={css`
            flex: 1;
            padding: ${spacing.milli} ${spacing.deci};
            border: none;
            border-radius: 10px;
            background: ${selectedSize === option.value ? 'white' : 'transparent'};
            color: ${selectedSize === option.value ? 'var(--text-color)' : colors.silver};
            box-shadow: ${selectedSize === option.value ? '0 1px 3px rgba(0, 0, 0, 0.08)' : 'none'};
            font-family: inherit;
            font-size: ${option.fontSize};
            font-weight: ${selectedSize === option.value ? 500 : 400};
            cursor: pointer;
            transition: all 0.15s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;

            &:hover {
              color: var(--text-color);
            }

            html[data-theme='dark'] & {
              background: ${selectedSize === option.value ? colors.liquorice : 'transparent'};
              color: ${selectedSize === option.value ? 'var(--text-color)' : colors.cloud};
            }
          `}
        >
          Aa
        </button>
      ))}
    </div>
  );
};

export default FontSizeSelector;
